import React from "react";
import PropTypes from "prop-types";
import SidebarIconSvg from "./SidebarIconSvg";

const SidebarIconClipboardList = ({ className, size }) => (
  <SidebarIconSvg className={className} size={size}>
    <rect x="5" y="4" width="14" height="17" rx="2" />
    <path d="M9 4v-1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1" />
    <line x1="9" y1="11" x2="15" y2="11" />
    <line x1="9" y1="15" x2="13" y2="15" />
  </SidebarIconSvg>
);

SidebarIconClipboardList.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number
};

export default SidebarIconClipboardList;
